import * as angular from "angular";
import {PackageConfigurationEntity} from "../models/package-configuration.model";
import {CustomFieldModel} from "../models/custom-field.model";

export class PackageConfigurationsRequestsService {

  /* @ngInject */
  constructor(private SettingsAPI, private $settings) {
  }

  getPackageFields() {
    const api = this.SettingsAPI.actions.getPackageFields;
    return this.$$call(api, {}, {}, {});
  }

  createPackageField(field: CustomFieldModel) {
    const api = this.SettingsAPI.actions.createPackageField;
    return this.$$call(api, {}, field, {});
  }

  updatePackageField(id: string, field: CustomFieldModel) {
    const api = this.SettingsAPI.actions.updatePackageField;
    return this.$$call(api, {}, field, {fieldId: id});
  }

  deletePackageField(id: string) {
    const api = this.SettingsAPI.actions.deletePackageField;
    return this.$$call(api, {}, {}, {fieldId: id});
  }

  getAllPackageConfigurations() {
    const api = this.SettingsAPI.actions.getAllPackageConfigurations;
    return this.$$call(api, {}, {}, {});
  }

  getOnePackageConfiguration(packageId: string) {
    const api = this.SettingsAPI.actions.getOnePackageConfiguration;
    return this.$$call(api, {}, {}, {packageId: packageId});
  }

  updatePackageConfiguration(packageConfiguration: PackageConfigurationEntity) {
    const api = this.SettingsAPI.actions.updatePackageConfiguration;
    return this.$$call(api, {}, packageConfiguration, {id: packageConfiguration.id});
  }

  createPackageConfiguration(packageConfiguration: PackageConfigurationEntity) {
    const api = this.SettingsAPI.actions.createPackageConfiguration;
    return this.$$call(api, {}, packageConfiguration, {});
  }

  // ******************************
  // Internal methods
  // ******************************

  private $$call(_apiCall, _params, _data, _options) {
    return this.$settings().$call(_apiCall, _params, _data, _options);
  }

}

angular
  .module('bringoz.admin.site-preferences')
  .service('packageConfigurationsRequestsService', PackageConfigurationsRequestsService);
